import type {Locale} from "antd/lib/locale";
import deDE from "antd/locale/de_DE";

export function getLocale() {


  return {
    localeName: "de_DE",
    localeIntl: "de-DE",
    locale: deDE as Locale,
  }
}